import '@adyen/adyen-web/styles/adyen.css'
import '@web-publish-id/wallet-pay/styles/wallet-pay.css'
import PaymentComponentCore from './core'

export default new PaymentComponentCore()
